import { render, staticRenderFns } from "./Newsbot.vue?vue&type=template&id=38192bbf&scoped=true&"
import script from "./Newsbot.vue?vue&type=script&lang=js&"
export * from "./Newsbot.vue?vue&type=script&lang=js&"
import style0 from "./Newsbot.vue?vue&type=style&index=0&id=38192bbf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38192bbf",
  null
  
)

export default component.exports